export type DropDrownValueType = { value: string; disabled: boolean; representation: string };

export type TableDataType = {
  key: string | null;
  name: string | null;
  matchScore: number | null;
  address: string | null;
  goldenRecord: boolean | null;
  countryCode: string | null;
  streetNumber: string | null; // new
  gln: string | null;
  commercialRegisterId: string | null;
  taxData: string | null;
  postalCode: string | null;
  city: string | null;
  markantId: string | null;
};

export const DEFAULT_DROPDOWN_SELECTED: TableDataType = {
  key: null,
  name: null,
  address: null,
  streetNumber: null,
  postalCode: null,
  city: null,
  commercialRegisterId: null,
  gln: null,
  markantId: null,
  countryCode: '',
  goldenRecord: false,
  matchScore: 0,
  taxData: null, // taxNumber | salesTaxID
};

export const TABLE_KEYS: (keyof Omit<TableDataType, 'matchScore' | 'goldenRecord'>)[] = [
  'name',
  'address',
  'streetNumber',
  'postalCode',
  'city',
  'countryCode',
  'commercialRegisterId',
  'taxData',
  'gln',
  'markantId',
];
